const keyboardDatePickerFormService = {
  label: 'Data do Serviço'
};

export default keyboardDatePickerFormService;
